import {
  FiUsers,
  FiMapPin,
  FiTool,
  FiHeadphones,
} from "react-icons/fi";
import cleaning from "../../assets/Services_img/cleaning.jpg";
import filter from "../../assets/Services_img/filter.jpg";
import maintain from "../../assets/Services_img/glovebox_maintain.jpg";
import seal from "../../assets/Services_img/seal.webp";
import techSupport from "../../assets/Services_img/techSupport.jpg";
import vaccuum from "../../assets/Services_img/vaccum.jpg";

import cl_1 from "../../assets/client_logo/momentive.png";
import cl_2 from "../../assets/client_logo/jain.png";
import cl_3 from "../../assets/client_logo/bbllc.png";
import cl_4 from "../../assets/client_logo/shintech.png";
import cl_5 from "../../assets/client_logo/tifr.png";
import cl_6 from "../../assets/client_logo/iith.png";
import cl_7 from "../../assets/client_logo/rv.png";
import cl_8 from "../../assets/client_logo/bms.png";
import cl_9 from "../../assets/client_logo/iisc.png";

export const ServiceData = {
  hero: {
    imgUrl:
      maintain,
    title: "Professional ",
    title2: "Services",
    SubTitle:
      "Comprehensive Maintenance, Support & Lifecycle Management Solutions",
  },

  serviceCardList: {
    title: "Our Service Offerings",
    description:
      "ProRes provides specialized glovebox services to ensure operational reliability, atmosphere integrity, and long-term system performance across research and industrial environments.",
    list: [
      {
        id: 1,
        title: "Glovebox Inspection & Preventive Maintenance",
        tagline:
          "Ensure system integrity, safety, and consistent performance.",
        description:
          "Detailed inspection and preventive maintenance of gloves, ports, viewing panels, feedthroughs, pressure control systems, and structural integrity to minimize downtime and extend system life.",
        img: maintain,
        serviceCategory: "gloveboxMaintan",
        ctaText: "See Details",
        ctaUrl: "gi-pm"
      },
      {
        id: 2,
        title: "Vacuum & Inert Gas System Servicing",
        tagline: "Reliable vacuum stability and ultra-high purity gas flow.",
        description:
          "Complete servicing of vacuum pumps, gas supply lines, pressure regulators, and purge systems to ensure contamination-free inert atmosphere operation.",
        img: vaccuum,
        serviceCategory: "vaccumGasService",
        ctaText: "See Details",
        ctaUrl: "vacum-inert"
      },
      {
        id: 3,
        title: "Filter & Purification Media Replacement",
        tagline: "Restore optimal atmosphere purity and efficiency.",
        description:
          "Replacement and servicing of HEPA filters, activated carbon filters, molecular sieve cartridges, and copper catalyst purification media for sustained low O₂ and H₂O levels.",
        img: filter,
        serviceCategory: "filterPurification",
        ctaText: "See Details",
        ctaUrl: "filter-purify"
      },
      {
        id: 4,
        title: "Seal, Gasket & O-Ring Replacement",
        tagline: "Maintain leak-tight and pressure-stable systems.",
        description:
          "Professional replacement of antechamber seals, door gaskets, feedthrough O-rings, and critical sealing components to preserve airtight operation.",
        img: seal,
        serviceCategory: "sealGasketReplace",
        ctaText: "See Details",
        ctaUrl: "seal-gasket"
      },
      {
        id: 5,
        title: "Sensor Cleaning, Calibration & Validation",
        tagline: "Accurate atmosphere monitoring you can trust.",
        description:
          "Precision cleaning, calibration, and functional validation of oxygen and moisture analyzers to ensure accurate real-time monitoring and control.",
        img: cleaning,
        serviceCategory: "sensorCleaning",
        ctaText: "See Details",
        ctaUrl: "sensor-clean"
      },
      {
        id: 6,
        title: "Customization, Upgrades & Technical Support",
        tagline: "Tailored solutions for evolving applications.",
        description:
          "Design modifications, system expansions, spare parts supply, retrofits, automation integration, and dedicated after-sales technical support for long-term reliability.",
        img: techSupport,
        serviceCategory: "techSupport",
        ctaText: "See Details",
        ctaUrl: "techSupport"
      },
    ],
  },

  processSection: {
    title: "Our Service Process",
    description:
      "A structured, transparent approach designed to deliver reliable results with minimal disruption to your operations.",
    stepsList: [
      {
        title: "Technical Consultation",
        description:
          "We understand your application, system configuration, and service requirements to recommend the most effective solution.",
        icon: <FiUsers size={26} />,
      },
      {
        title: "On-Site Assessment",
        description:
          "Our engineers perform a detailed on-site evaluation to identify system condition, risks, and service scope.",
        icon: <FiMapPin size={26} />,
      },
      {
        title: "Service Execution",
        description:
          "Certified technicians execute the service using validated procedures, ensuring safety, precision, and compliance.",
        icon: <FiTool size={26} />,
      },
      {
        title: "Post-Service Support",
        description:
          "Comprehensive reporting, performance verification, and ongoing technical support to maintain long-term system health.",
        icon: <FiHeadphones size={26} />,
      },
    ],
  },

  clientLogo: {
    title: "Trusted by Leading Institutions & Industries",
    logoList: [
      cl_1, cl_2, cl_3, cl_4, cl_5, cl_6, cl_7, cl_8, cl_9
    ],
  },
};
